import { render, staticRenderFns } from "./order.vue?vue&type=template&id=0f8f5f4c"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=0f8f5f4c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8f5f4c')) {
      api.createRecord('0f8f5f4c', component.options)
    } else {
      api.reload('0f8f5f4c', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=0f8f5f4c", function () {
      api.rerender('0f8f5f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dispatch/result/components/order.vue"
export default component.exports